import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import RootStoreContext from '~/contexts/RootStoreContext';
import { selectors as commonSelectors } from '~/domains/common';
import {
  selectors as agentScannersSelectors,
  actions as agentScannersActions
} from '~/domains/agentScanners';
import ScannerDetail from './ScannerDetail';

const mapStateToProps = (state, { match: { params } }) => {
  const scanners = agentScannersSelectors.scanners(state);
  const scanner = scanners.find((s) => s.id === params.scannerId);
  const profile = commonSelectors.profile(state);
  const organizationId = profile?.organization?.id;

  return {
    scanner,
    scannerId: params.scannerId,
    organizationId,
    isFetching: agentScannersSelectors.isFetchingScanners(state),
    scannerRuns: agentScannersSelectors.scannerRuns(state),
    isFetchingScannerRuns: agentScannersSelectors.isFetchingScannerRuns(state),
    scannerRunsError: agentScannersSelectors.scannerRunsError(state)
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadScannerRuns: (organizationId, scannerId, page, size) =>
    dispatch(
      agentScannersActions.loadScannerRuns(
        organizationId,
        scannerId,
        page,
        size
      )
    ),
  clearScannerRuns: () => dispatch(agentScannersActions.clearScannerRuns())
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps, null, {
    context: RootStoreContext
  })
)(ScannerDetail);
